import type { CreateWelcomePostsPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { WelcomePost } from '../types'
import { getWelcomePostPayload } from './getWelcomePostPayload'

export const getCreateWelcomePostPayload = async (welcomePost: WelcomePost) => {
  const post = await getWelcomePostPayload(welcomePost)

  return {
    welcomePost: {
      type: 'Single',
      post,
    },
  } as CreateWelcomePostsPayload
}
